import { trackTimings, alt } from '@reverbdotcom/discovery-ui';
import { configureMParticle } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { frontendCurrentUser, parseMeta } from '@reverbdotcom/discovery-ui/src/components/parse_meta';
import { DEPLOY_ENV } from '@reverbdotcom/env';

import I18n from 'i18n-js';
import moment from 'moment';

import 'moment/locale/de';
import 'moment/locale/en-au';
import 'moment/locale/en-ca';
import 'moment/locale/en-gb';
import 'moment/locale/en-ie';
import 'moment/locale/en-il';
import 'moment/locale/en-nz';
import 'moment/locale/es';
import 'moment/locale/es-us';
import 'moment/locale/fr';
import 'moment/locale/fr-ca';
import 'moment/locale/ja';
import { setScrollbarWidthVars } from '@reverbdotcom/cadence/components/helpers/setScrollbarWidthVars';

let didInit = false;

const AppInitializer = {
  init() {
    if (didInit) { return; }

    this.initializeAltStores();
    this.initializeLocale();
    this.fixFacebookHash();
    this.configureMparticle();
    trackTimings();
    setScrollbarWidthVars();

    didInit = true;
  },

  fixFacebookHash() {
    // Facebook adds a strange hash to our url when we log in, which
    // can break tab navigation. This removes it.
    if (window.location.hash === '#_=_') window.location.hash = '';
  },

  initializeLocale() {
    const userConfig = frontendCurrentUser();
    const translations = parseMeta('js-translations');

    if (userConfig) {
      I18n.locale = userConfig.user.fiveDigitLocale || I18n.defaultLocale;

      moment.locale(I18n.locale);

      if (translations) {
        if (I18n.locale.includes('-') && !I18n.locale.includes(I18n.defaultLocale)) {
          const [fallbackLocale] = I18n.locale.split('-');
          I18n.translations[fallbackLocale] = translations[fallbackLocale];
        }

        I18n.translations[I18n.locale] = translations[I18n.locale];
      }
    }
  },

  initializeAltStores() {
    const stores = document.getElementById('alt-bootstrap');
    // This value is duplicated in two places, so let's share it
    const currentUser = frontendCurrentUser();

    if (stores && currentUser) {
      const parsedStores = JSON.parse(stores.textContent);

      alt.bootstrap(JSON.stringify({
        ...parsedStores,
        UserStore: currentUser.user,
      }));
    }
  },

  configureMparticle() {
    // FIXME: consolidate "enable mparticle" envvars
    if (DEPLOY_ENV === 'test') return;

    const userConfig = frontendCurrentUser();
    const appConfig = parseMeta('app-config-meta');

    if (userConfig && appConfig) {
      configureMParticle(userConfig.user, appConfig.config.inverseReverseExchangeRates);
    }
  },
};

export default AppInitializer;
